import React, { useState, useEffect, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import Modal from "common/Modal";
import styled from "styled-components";
import NumberInput from "common/NumberInputWithSpinnerState";
import Loading from "common/Loading";

const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 30px;
`;

const ConfirmationWrapper = styled.div`
  margin-top: 25px;
  h4 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    i {
      font-size: 22px;
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }
`;

const ErrorMessage = styled.span`
  text-align: left;
`;

const InputsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const InputWrapper = styled.div`
  width: 40%;
  margin-right: 20px;
`;

const DateSelector = ({ date, setDate }) => {
  const [year, month, day] = date.split("-");
  return (
    <InputsWrapper>
      <InputWrapper>
        <NumberInput
          name="year"
          label="Year"
          min={0}
          max={3000}
          step={1}
          initialValue={year}
          onChange={(value) => setDate({ year: value, month, day })}
          hideReset={true}
        />
      </InputWrapper>
      <InputWrapper>
        <NumberInput
          name="month"
          label="Month"
          min={1}
          max={12}
          step={1}
          initialValue={month}
          onChange={(value) => setDate({ year, month: value, day })}
          hideReset={true}
        />
      </InputWrapper>
      <InputWrapper>
        <NumberInput
          name="day"
          label="Day"
          min={1}
          max={31}
          step={1}
          initialValue={day}
          onChange={(value) => setDate({ year, month, day: value })}
          hideReset={true}
        />
      </InputWrapper>
    </InputsWrapper>
  );
};

const DateModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [bqn, setBqn] = useState("");
  const [dateSelected, setDateSelected] = useState("");
  const [errorFooter, setErrorFooter] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  useEffect(
    () =>
      actions.recv("set-date", (value) => {
        const { date, time, bqn } = value;
        setBqn(bqn);
        setDate(date);
        setTime(time);
        setLoading(false);
        doOpen();
      }),
    []
  );
  const doOpen = () => {
    setShowConfirm(false);
    setErrorFooter("");
    setDateSelected("");
    setOpen(true);
  };
  const doClose = () => setOpen(false);

  const doApply = () => {
    if (!showConfirm) {
      setShowConfirm(true);
    } else {
        setLoading(true);
      ifCl
        .run(
          `system date local ${dateSelected} ${time} bqn-id ${
            mode === "cluster" ? bqn : bqnId
          }`
        )
        .then((response) => {
            setLoading(false);
          const indexError = response.indexOf("%ERR");
          if (indexError !== -1) {
            const error = response.slice(indexError, response.length);
            throw Error(error);
          } else {
            doClose();
          }
        })
        .catch((error) => {
            setErrorFooter(`Error: ${error}`)
            setLoading(false);
        }
        );
    }
  };

  const handleDate = (value) => {
    const { year, month, day } = value;
    setDateSelected(`${year}-${month}-${day}`);
  };

  if (!open) return null;
  return (
    <Modal
      title={`Set Date${bqn ? ` for BQN ${bqn}` : ""}`}
      superIcon="edit"
      onApply={doApply}
      closeLabel={!errorFooter ? "CANCEL" : loading ? null : "CLOSE"}
      onClose={doClose}
      applyLabel={!errorFooter && !loading && dateSelected ? "APPLY" : null}
      content={() => {
        return (
          <>
            <DateSelector date={date} setDate={handleDate} />
            {showConfirm && !errorFooter && !loading ? (
              <ConfirmationWrapper>
                <h4>
                  <i className="material-icons">info</i> Confirm time change?
                </h4>
                <div>
                  Changing the time by more than a few minutes may cause
                  a disruption in traffic
                  of 10 seconds to 2 minutes, depending on the number of
                  interfaces, CPU cores, and memory size.
                  In any case, after a time change, it is
                  recommended to perform a software reload of the active bqn
                  package in Administration &gt; Software.
                </div>
              </ConfirmationWrapper>
            ) : null}
            {loading ?<LoadingWrapper><Loading /></LoadingWrapper>:null}
          </>
        );
      }}
      footerMessage={
        errorFooter !== "" ? (
          <ErrorMessage className="color-red">
            <h5>{errorFooter}</h5>
          </ErrorMessage>
        ) : null
      }
    />
  );
};

export default DateModal;
